// Real-mode Delivery-Log fetcher — swap-in for getDeliveryLogMock() (task [2.5]).
// Relative path; the installed fetch-patch handles VITE_API_URL prefixing, the
// MSAL bearer, and non-2xx rejection. See overview/real.ts header for the full
// contract + the untested-against-real-backend caveat (proposal risk table).

import { z } from 'zod';

import type { DeliveryLogData } from './mock';

const deliveryStatusSchema = z.enum([
	'delivered',
	'failed',
	'pending',
	'bounced',
]);

const deliveryEventTypeSchema = z.enum([
	'sent',
	'delivered',
	'bounced',
	'failed',
	'pending',
]);

const deliveryEventSchema = z.object({
	type: deliveryEventTypeSchema,
	timestamp: z.string(),
});

const deliveryInsightTierSchema = z.enum([
	'needs-attention',
	'possible-improvement',
	'doing-great',
]);

const deliveryInsightSchema = z.object({
	tier: deliveryInsightTierSchema,
	message: z.string(),
});

const deliveryRecordSchema = z.object({
	id: z.string(),
	recipient: z.string(),
	subject: z.string(),
	provider: z.string(),
	status: deliveryStatusSchema,
	timestamp: z.string(),
	events: z.array(deliveryEventSchema),
	contentPlainText: z.string(),
	contentHtml: z.string(),
	contentRaw: z.string(),
	insights: z.array(deliveryInsightSchema),
});

const deliveryLogDataSchema = z.object({
	records: z.array(deliveryRecordSchema),
	total: z.number(),
});

export async function getDeliveryLog(): Promise<DeliveryLogData> {
	const response = await fetch('/delivery-log');
	const json: unknown = await response.json();
	return deliveryLogDataSchema.parse(json);
}
